/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2020-12-10 14:44:05
 */
import React, { Component } from 'react'
import './index.css'

import { Form, Input, Button } from 'antd';

class MyPassword extends Component {

    render() {
        return (
            <div>
              放置修改密码界面
            </div>
        )
    }
}

export default MyPassword